import { BsSearch } from "react-icons/bs";
import { IoCloseCircle } from "react-icons/io5";
import { netural400, primaryGrey, neturalBlack } from "../../constants/color";
import AppInput from "../app-input.component/app-input.component";

const SliceConfigurationRow = ({
  sliceNumber,
  color,
  productSearch,
  discount,
  onProductSearchChange,
  onDiscountChange,
  onProductInputClick,
  disabled,
  discountDisabled = false,
  productError,
  discountError,
  showDiscount = true,
}) => {
  const resolvedDiscountDisabled = disabled || discountDisabled;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        marginBottom: "12px",
      }}
    >
      {/* Color dot */}
      <div
        style={{
          width: "12px",
          height: "12px",
          borderRadius: "50%",
          backgroundColor: color,
          flexShrink: 0,
        }}
      />

      {/* Slice label */}
      <div
        style={{
          backgroundColor: color,
          color: "#fff",
          padding: "4px 10px",
          borderRadius: "6px",
          fontSize: "12px",
          fontWeight: "600",
          whiteSpace: "nowrap",
          minWidth: "60px",
          textAlign: "center",
        }}
      >
        Slice {String(sliceNumber).padStart(2, "0")}
      </div>

      {/* Search product input */}
      <div style={{ flex: 1 }}>
        <AppInput
          type="display"
          value={productSearch}
          placeholder="Search product..."
          leftIcon={<BsSearch color={netural400} />}
          clearable
          onClear={() => {
            onProductSearchChange("");
          }}
          onClick={onProductInputClick}
          status={productError ? "error" : "normal"}
          helperText={productError}
          showDropdown
          disabled={disabled}
        />
      </div>

      {/* Discount input */}
      {showDiscount && (
        <div style={{ width: "80px" }}>
          <AppInput
            type="number"
            size="small"
            min={0}
            max={100}
            step={1}
            placeholder="0"
            value={discount}
            disabled={resolvedDiscountDisabled}
            onChange={(e) => onDiscountChange(e.target.value)}
            suffix={<span style={{ color: netural400 }}>%</span>}
            status={discountError ? "error" : "normal"}
            helperText={discountError}
            inputStyle={{
              textAlign: "center",
              fontVariantNumeric: "tabular-nums",
            }}
          />
        </div>
      )}
    </div>
  );
};

export default SliceConfigurationRow;
